var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user__global__alert global__alert" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: {
            ok: function($event) {
              return _vm.deleteAlert(_vm.deleteAlertId)
            }
          },
          model: {
            value: _vm.confirmDeleteAlert,
            callback: function($$v) {
              _vm.confirmDeleteAlert = $$v
            },
            expression: "confirmDeleteAlert"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this alert?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-global-alert-detail",
          attrs: { size: "lg", "hide-footer": "", id: "userGlobalAlertDetail" }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("\n      " + _vm._s(_vm.alertTitle) + "\n      "),
            _c("p", { staticClass: "notification-sender" }, [
              _vm._v(
                "\n        sent by " +
                  _vm._s(_vm.alertSender) +
                  " @ " +
                  _vm._s(_vm.getLocalAlertTime(_vm.alertTime)) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.alertDetail) } })
        ],
        2
      ),
      _vm._v(" "),
      _c("HeaderControls", { attrs: { namespace: _vm.namespace } }),
      _vm._v(" "),
      _c("div", { staticClass: "fixed-top-bar-padding" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "deliverable-header" }, [
            _c(
              "h2",
              [
                _vm._m(0),
                _vm._v(
                  "\n                  Your Messages\n\n                \t"
                ),
                typeof _vm.userAlerts.data != "undefined" &&
                _vm.userAlerts.data.length > 0
                  ? [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-inline-block float-right saved-views-area pt-15"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-theme",
                              attrs: { variant: "theme" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.makeAllAlertsRead.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                \t\t    Mark All as Read\n                \t\t    "
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.runningTask,
                                      expression: "runningTask"
                                    }
                                  ],
                                  staticClass:
                                    "ml-2 spinner-border spinner-border-sm text-primary",
                                  attrs: { role: "status" }
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Marking...")
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "global-alerts-status" }, [
            typeof _vm.userAlerts.data != "undefined" &&
            _vm.userAlerts.data.length == 0
              ? _c("span", [_c("h2", [_vm._v("You have no notifications.")])])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "alert-item clearfix" }, [
              typeof _vm.userAlerts.data != "undefined" &&
              _vm.userAlerts.data.length > 0
                ? _c(
                    "ul",
                    { staticClass: "list-unstyled" },
                    _vm._l(_vm.userAlerts.data, function(alert, index) {
                      return _c(
                        "li",
                        {
                          key: "alert-" + index,
                          staticClass: "cursor-pointer",
                          class:
                            alert.status == 0
                              ? "unread-notification"
                              : "read-notification",
                          on: {
                            click: function($event) {
                              return _vm.setAlert(alert)
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c("span", { staticClass: "info-bubbles" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "initials badge badge-primary cursor-pointer"
                                },
                                [
                                  _vm._v(
                                    "\n                                      " +
                                      _vm._s(
                                        _vm._f("textInitials")(alert.sender)
                                      ) +
                                      "\n                                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "remove-alert cursor-pointer",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.confirmDeleteAlert = true
                                    _vm.deleteAlertId = alert.id
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-trash" })]
                            ),
                            _vm._v(" "),
                            alert.status == 0
                              ? _c("span", { staticClass: "alert-status" }, [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass: "fas fa-circle",
                                    class:
                                      alert.status == 0
                                        ? "text-primary"
                                        : "text-primary",
                                    attrs: {
                                      title:
                                        alert.status == 0 ? "Unread" : "Read"
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", { staticClass: "details" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "alert__name cursor-pointer fw-bold"
                                },
                                [_vm._v(_vm._s(alert.title))]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "notification-sender" },
                                [
                                  _c("span", { staticClass: "fw-bold" }, [
                                    _vm._v(
                                      _vm._s(alert.sender) +
                                        " @ " +
                                        _vm._s(
                                          _vm.getLocalAlertTime(
                                            alert.created_at
                                          )
                                        )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "note-message",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.processMessage(alert.message)
                                  )
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("pagination", {
                  attrs: { data: _vm.userAlerts, limit: 5 },
                  on: { "pagination-change-page": _vm.onChangePage }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: "Edit Deliverable"
          },
          on: {
            hide: _vm.editDeliverableModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: {
              allContacts: _vm.allContacts,
              namespace: _vm.namespace,
              tabIndex: _vm.tabIndex
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialModal",
            title: "Edit Social Deliverable"
          },
          on: {
            hide: _vm.editSocialModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditSocialModal", {
            ref: "refEditSocialModal",
            attrs: { namespace: _vm.namespace, tabIndex: _vm.tabIndex }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": "",
            id: "editOrganicSocialMediaPlanModal",
            title: "Edit Organic Social Media Plan"
          },
          on: {
            hide: _vm.editOrganicSocialModalPlanHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditOrganicSocialMediaPlanModal", {
            ref: "refEditOrganicSocialMediaPlanModal",
            attrs: { tabIndex: _vm.tabIndex, namespace: _vm.namespace }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "media-call-icon pointer-default" }, [
      _c("img", {
        attrs: {
          width: "30px",
          src: require("@/csmworkflow/img/bell-module.svg")
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }